import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../../state/reducers';

const mapState = ({ results, queryParams }: StateType) => ({
  enterprise: results.snippets.enterprise,
  lawyer: results.snippets.professional,
  hasLegalBasis: !!results.snippets.legalBasis,
  commentariesSnippet: results.snippets.commentaries,
  legislationSnippet: results.snippets.law,
  originalQueryKey: queryParams.originalQueryKey,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
